import { buildListParams, type ListParams } from "../build-list-params";
import type { FilterFieldsConfig } from "../types";
import { useRouteListSearch } from "./use-route-list-search";

/**
 * Generic list-params hook — reads the current route's typed URL search and
 * folds it (filters + free-text search + the canonical `sort` string) into the
 * `@birdwatch/client` list DSL. Replaces the per-feature `use-*-list-params`
 * shims: those each re-implemented `buildListParams` + a private
 * `sortsToSortString`; this is the one shared hook.
 *
 *   const params = useListParams(invoiceFilterFields);
 *   // → { filters, search?, sort? } ready for the _api builder
 *
 * Pass `options.search` to fold an explicit search object instead of the
 * current route's — the sidebar prefetch hooks use this with the persisted
 * search of the DESTINATION route, which the hovered link navigates to.
 *
 * The keys are the nearest `FilterUrlKeysProvider`'s (the defaults without one).
 */
export function useListParams(
  fields: FilterFieldsConfig,
  options?: { search?: Record<string, unknown> },
): ListParams {
  const search = useRouteListSearch(options?.search);
  return buildListParams({ fields, search });
}
